import React, {Component} from "react";
import {Button, message, Modal} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './edit-form/EditForm.js';
import ViewForm from './ViewForm.js';
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";


const confirm = Modal.confirm;
const basicUrl = "/hjgl/";

/**
 * 环节管理列表
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-14 10:37:09
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            tempData: {}, //临时存放操作行的数据
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
            },
            showOperationBtn: false, //是否显示删除操作按钮
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }
    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        let pkid = record.PKID;
        this.setState({tempData: record});
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('viewFlag');
                }
            })
    }

    //选择行后显示删除操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        let hjlx = record.HJLX;
        //如果是固定环节则不能删除
        if (hjlx == '1') {
            message.warning("固定类型环节不能删除！");
            return;
        }
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        let selectedRows = this.refs.nhTable.state.selectedRows;
        if (selectedRowKeys && selectedRowKeys.length > 0) {

            for (let key in selectedRows) {
                if (selectedRows[key].HJLX == '1') {
                    message.warning("固定类型环节不能删除！");
                    return;
                }
            }

            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");

        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    render() {

        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '环节名称',
                width: '150px',
                dataIndex: 'HJMC',
                searchType:"input"
            }, {
                title: '类型',
                width: '100px',
                dataIndex: 'HJLXMC',
                searchType:"select"
            }, {
                title: '环节代码',
                width: '100px',
                dataIndex: 'HJDM',
                searchType:"input"
            }, {
                title: '环节描述',
                width: '120px',
                dataIndex: 'HJMS',
                searchType:"input"
            }
        ];

        //行内操作
        const action = [
            {title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxgl_lcgl_hjgl:detail'},
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_lcgl_hjgl:update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_lcgl_hjgl:delete'}
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxxt_lcgl_hjgl_queryPage"}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {
                            hasAuth('zhxg_yxgl_lcgl_hjgl:add') ?
                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_lcgl_hjgl:delete') ?
                                <Button type="danger" ghost style={{
                                    marginLeft: 10,
                                    display: this.state.showOperationBtn ? undefined : 'none'
                                }}
                                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                                  title="新增迎新环节"
                                  visible={this.state.frameVisibleMap.addFlag}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm"/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改环节信息"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title={this.state.tempData.HJMC + '—环节业务项'}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}
                >
                    <ViewForm initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default IndexComponent;



// WEBPACK FOOTER //
// ./components/lcgl/hjgl/index.js